import { ACTION_DIALOG_CLOSE, MOUNT_COMPONENTS, THEME_WISHLIST_UPDATED } from 'events';
import Tracking from 'lib/tracking';
import Wishlist from 'lib/wishlist';
import { component } from 'picoapp';

import { clear, stringToNode } from 'utils/node';
import { placeholderItem } from 'utils/product-item';

export default component((node, ctx) => {
  const itemContainer = node.querySelector('[data-items]');

  const fetchProduct = (handle) => fetch(`/products/${handle}?view=wishlist-item`);

  const initEmpty = () => {
    const empty = node.querySelector('[data-empty]');

    empty.addEventListener('click', () => {
      Wishlist.empty();

      ctx.emit(THEME_WISHLIST_UPDATED, { wishlist: Wishlist.items });

      node.classList.add('is-empty');
      clear(itemContainer);
    });
  };

  const initItems = () => {
    Wishlist.items.forEach(async (item, index) => {
      const placeholder = stringToNode(`
        <div class="${itemContainer.dataset.items}">${placeholderItem(index)}</div>
      `);
      itemContainer.appendChild(placeholder);

      fetchProduct(item.handle).then(async (response) => {
        if (response.ok) {
          const view = await response.text();

          itemContainer.replaceChild(
            stringToNode(
              `<div class="${itemContainer.dataset.items}" data-handle="${item.handle}">${view}</div>`,
            ),
            placeholder,
          );

          ctx.emit(MOUNT_COMPONENTS);
        } else if (response.status === 404) {
          Wishlist.remove(item.handle);
          placeholder.parentNode.removeChild(placeholder);
        }
      });
    });

    Tracking.trackViewItemList({
      productHandles: Wishlist.items.map((item) => item.handle),
      placement: 'wishlist',
    });
  };

  const replaceItem = (handle, replacement) => {
    const placeholder = itemContainer.querySelector(`[data-handle="${handle}"]`);

    fetchProduct(replacement).then(async (response) => {
      const view = await response.text();

      itemContainer.replaceChild(
        stringToNode(
          `<div class="${itemContainer.dataset.items}" data-handle="${replacement}">${view}</div>`,
        ),
        placeholder,
      );

      ctx.emit(MOUNT_COMPONENTS);
    });
  };

  initEmpty();
  initItems();

  document.addEventListener('theme:product:swap', ({ detail }) => {
    const { handle, product } = detail;

    if (handle === product) {
      return;
    }

    Wishlist.replace(product, handle);
    replaceItem(product, handle);

    ctx.emit(ACTION_DIALOG_CLOSE);
  });

  if (Wishlist.items.length === 0) {
    node.classList.add('is-empty');
  }

  node.addEventListener('click', (event) => Tracking.selectItemCallback(event, false, true));
});
